import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { GeneralService } from 'src/app/providers/general/general.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-refyne',
  templateUrl: './refyne.component.html',
  styleUrls: ['./refyne.component.scss']
})
export class RefyneComponent implements OnInit {
  requestedData: any = [];
  catId;
  language;
  hseDocuments: any;
  category:any;

  constructor(private activeroute: ActivatedRoute,
    private dashboardService: DashboardService,
    private generalServe: GeneralService,
    private notifyService: NotificationService ) { 
  }

  ngOnInit(): void {
    this.activeroute.queryParams.subscribe(params => {
          console.log(params); 
          this.catId = params.cat_id;
          this.language = params.lang;} );

          if (this.catId == 1) {
            this.category = 'User Flow Journey';
          } else if (this.catId == 2) {
            this.category = 'FAQ';
          } else if(this.catId == 3){
            this.category = 'Launch Deck';
          } 

          const data = {
            cat_id: this.catId,
            language : this.language
          };

       


  }

  back(): void{
    this.generalServe.back();

  }

}
